namespace Matrix.Data {
    export interface AccountValueRow {
        AccountCode?: string;
        SourceCode?: string;
        InstanceCode?: string;
        GrossAssetValue?: number;
        NetAssetValue?: number;
        Duration?: number;
        AsAtDate?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace AccountValueRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'AccountCode';
        export const localTextPrefix = 'Data.AccountValue';
        export const deletePermission = 'NoPermission';
        export const insertPermission = 'NoPermission';
        export const readPermission = 'Read:AccountValue';
        export const updatePermission = 'NoPermission';

        export declare const enum Fields {
            AccountCode = "AccountCode",
            SourceCode = "SourceCode",
            InstanceCode = "InstanceCode",
            GrossAssetValue = "GrossAssetValue",
            NetAssetValue = "NetAssetValue",
            Duration = "Duration",
            AsAtDate = "AsAtDate",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
